module.exports = __webpack_public_path__ + "img/3.d88b916e.jpg";